import type User from 'modules/core/store/models/User'

import ValidateIban from 'modules/payroll_bundle/lib/ValidateIban'
import type PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'

export const disablePaymentItem = (
  paymentItem: PaymentItem,
  user: User | null | undefined
): boolean =>
  !user ||
  !paymentItem.attributes.amount ||
  !paymentItem.attributes.employee_id ||
  !paymentItem.attributes.bank_account ||
  !ValidateIban(paymentItem.attributes.bank_account)
